import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import logo from "../../../../assets/logo.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

function InvoiceModal({ modal, setModal, order }) {
	const { t } = useTranslation();
	const lang = useSelector((state) => state?.lang.lang);

	return (
		<Modal
			show={modal}
			onHide={setModal}
			className={lang === "en" ? "en" : "ar"}>
			<div className="pt-3 text-center">
				<img src={logo} alt="logo" width={124} />
			</div>
			<div className="py-3 px-4">
				<div className="d-flex justify-content-between mt-3">
					<div>
						<p>{order?.user?.username}</p>
						<p>
							{lang === "en"
								? order?.user_address?.area?.name_en
								: order?.user_address?.area?.name_ar}
						</p>
						<p>
							{t("status")}: {t(order?.status)}
						</p>
					</div>
					<div>
						<p>
							{t("Order Date")} : {order?.createdAt?.split("T")[0]}
						</p>
						<p>
							{t("Order ID")} : #{order?.id}
						</p>
						<p>
							{t("Payment Method")} :{" "}
							{order?.payment_method === "visa"
								? t(order?.payments[0]?.payment_type)
								: t(order?.payment_method)}
						</p>
					</div>
				</div>
				<div className="orders my-3">
					<Row style={{ border: "1px solid #dedede", padding: "8px" }}>
						<Col md={7}>{t("Details")}</Col>
						<Col md={2}>{t("Quantity")}</Col>
						<Col md={3}>{t("Price")}</Col>
					</Row>
					{order?.sub_carts?.map((item) => {
						return (
							<Row
								style={{
									border: "1px solid #dedede",
									padding: "8px",
									alignItems: "center",
								}}>
								<Col
									md={7}
									className="d-flex justify-content-start align-items-center gap-12">
									<img
										src={item.product?.product_images[0].url}
										alt="product"
										width={80}
									/>
									<span>
										{lang === "en"
											? item?.product?.name_en
											: item?.product?.name_ar}
									</span>
								</Col>
								<Col md={2}>{item?.amount}</Col>
								<Col md={3}>{(item?.price * item?.amount)?.toFixed(3)}</Col>
							</Row>
						);
					})}
				</div>
				<Row>
					<Col md={9}>
						<div style={{ background: "#F8F8F8" }} className="p-3">
							<div className="d-flex justify-content-between">
								<p>{t("Sub Total")}</p>
								<p>
									{(order?.sub_total - order?.shipping_fee)?.toFixed(3)}{" "}
									{t("KWD")}
								</p>
							</div>
							{!!order?.coupon_name && (
								<div className="d-flex justify-content-between">
									<p>{t("Discount")}</p>
									{order?.coupon_type === "percentage" && (
										<p>{order?.coupon_value} %</p>
									)}
									{order?.coupon_type !== "percentage" && (
										<p>
											{order?.coupon_value?.toFixed(3)} {t("KWD")}
										</p>
									)}
								</div>
							)}
							<div className="d-flex justify-content-between">
								<p>{t("Delivery Charges")}</p>
								<p>
									{order?.shipping_fee?.toFixed(3)} {t("KWD")}
								</p>
							</div>
							<div className="d-flex justify-content-between">
								<p>{t("Total")}</p>
								<p>
									{order?.total?.toFixed(3)} {t("KWD")}
								</p>
							</div>
						</div>
					</Col>
				</Row>
			</div>
			<div className="modal-footer border-0">
				<button
					type="button"
					onClick={() => setModal(false)}
					className="btn me-auto btn-primary"
					data-dismiss="modal">
					{t("close")}
				</button>
			</div>
		</Modal>
	);
}

export default InvoiceModal;
